module.exports = "#admin-planned-actual-div {\r\n    min-height: 85vh;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/rm/planned-actual/planned-actual.component.css
// module id = ./src/app/rm/planned-actual/planned-actual.component.css
// module chunks = main